import { useState, useRef, useEffect } from "react";
import "./testimonial.css";

const testimonials = [
  { review: "Had a really great experience! Michael was very professional, friendly and helpful. He did an excellent job and paid great attention to detail. Everything was completed really well and I’m very happy with the result. Highly recommend Michael and would definitely use his service again!", author: "Vicky from Brighton" },
  { review: "I have known Michael for about 3 years and in that time he has done many jobs for me. I would highly recommend him as a perfectionist, with reasonable rates. He is always on time with a professional manner, courteous with an excellent work ethic. Therefore a good choice for all building needs.", author: "Jill from Elsternwick" },
  { review: "I highly recommend Michael and his team at Handyman in Melbourne. I had a few different jobs that needed doing around the house, including wall mounting my TV, some interior wall painting and painting part of my timber fence, and Michael did an excellent job with everything. If you're looking for a reliable handyman in Melbourne for TV mounting, painting, fence painting or general home maintenance, I would definitely recommend Michael and the team at Handyman in Melbourne. Very happy with the finished work and I’ll definitely contact them again when I have more jobs around the house.", author: "Nick from Chadstone" },
  { review: "Michael has been polite and professional easy to work with... Would recomend him 💯", author: "Rose from Doncaster" },
  { review: "Michael has helped us out in a several times in a commercial premises. Highly reliable and capable.", author: "Gabrelle from Hawthorn East" },
  { review: "Very grateful for Michael’s services. I needed someone to help with a trick assembled quick quickly and not only did he do an INCREDIBLE job he was so easy to work with, flexible with his time and comfortable to complete the job without me there. Will definitely use Michaela services again… probably soon! Thanks Michael", author: "Michelle from Elwood" },
  { review: "Fantastic service from start to finish. Arrived on time, worked efficiently, and the quality of the workmanship was excellent. Every installation was done neatly and professionally, and nothing was too much trouble. It’s hard to find a reliable handyman these days, but these guys exceeded our expectations. Highly recommended, and we’ll definitely be calling them again for future jobs.", author: "Jia from Oakleigh South" },
  { review: "Highly recommended. I needed a door modified to close properly within its frame. Michael was on time, was knowledgeable, communicated well and completed the job efficiently and to a high standard. Thanks Michael!", author: "Mary from Windsor"},
  { review: "Michael done a fantastic and clean job hanging three mirrors perfectly level and reasonably priced cannot complain will use him again.", author: "Alex from Oakleigh" },
  { review: "Michael was on time. Very good communication and very well presented. He was prepared for the job ahead. He did a great job and putting together all my household items. Thanks for the great work 100% recommend him.", author: "Tracey from Frankston" },
  { review: "Always professional, exceeds expectations. Super friendly and very helpful. Would recommend 10/10", author: "Umma from Keysborough" },
  { review: "The team was very efficient on time and great job", author: "Diane from Rowville" },
  { review: "Michael has done an incredible job measuring and fitting these wall cabinets and floating shelf for us. Hightly recommended!", author: "Adam from Glen Iris" },
  { review: "Michael did an amazing job on our decking. The design is meet our requirement perfectly and the quality is excellent. We’ve been using it for over a year now, and I still love it just as much as the first day. Highly recommend his work!", author: "Bella from Burwood"},
  { review: "Reliable, professional and fairly priced. They fixed multiple issues quickly and neatly. Highly recommended.", author: "Daniel from Hawthorn" },
  { review: "We needed an existing glass whiteboard installed on an office wall in Southbank and Michael was punctual, well priced and did a very good job. I will definitely reach out to him in the future.", author: "Acacia from Southbank" },
  { review: "The team did an excellent job repairing our wall after a damage. The work was fast, clean and well priced. Highly recommend their service!", author: "Lin from Oakleigh" },
  { review: "Michael was extremely professional, very reasonably priced , his work was superb. Highly recommend!", author: "Kirstie from Brighton"},
  { review: "Michael designed and built my wardrobe, and I couldn't be happier with the result. The quality is excellent, and his attention to detail really stands out. The wardrobe looks fantastic and fits perfectly in my space. Thank you so much, Michael — I will definitely work with him again in the future!", author: "Ricky from Burwood East"},
]

const TestimonialCard = ({ item }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [canExpand, setCanExpand] = useState(false);
  const quoteRef = useRef(null);
  const reviewerName = item.author.replace(/\s+from\s+.*/i, "");
  const reviewerInitial = reviewerName.charAt(0).toUpperCase();

  // Detect if quote is actually truncated by the 2-line clamp
  useEffect(() => {
    const el = quoteRef.current;
    if (!el) return;

    const checkOverflow = () => {
      // Temporarily force clamp styles to measure
      const wasClamped = el.classList.contains("clamp");
      if (!wasClamped) el.classList.add("clamp");
      const isOverflowing = el.scrollHeight > el.clientHeight + 1;
      if (!wasClamped) el.classList.remove("clamp");
      setCanExpand(isOverflowing);
    };

    checkOverflow();
    // Re-check on resize (card width can change)
    const ro = new ResizeObserver(checkOverflow);
    ro.observe(el);
    return () => ro.disconnect();
  }, [item.review]);

  return (
    <div className={`testimonial-card ${isExpanded ? "expanded" : ""}`}>
      <div className="reviewer-avatar" aria-hidden="true">{reviewerInitial}</div>
      <div className="stars" aria-label="5 out of 5 stars">★★★★★</div>
      <div className="testimonial-card-content">
        <p
          ref={quoteRef}
          className={`testimonial-quote ${isExpanded ? "" : "clamp"}`}
        >
          “{item.review}”
        </p>
        {canExpand && (
          <button
            className="read-more-btn"
            onClick={() => setIsExpanded(!isExpanded)}
            aria-expanded={isExpanded}
          >
            {isExpanded ? "Show less" : "Read full review"}{" "}
            <span aria-hidden="true">›</span>
          </button>
        )}
      </div>
      <div className="testimonial-reviewer">
        <span className="google-review-icon" aria-hidden="true">G</span>
        <p className="testimonial-author">{item.author}</p>
      </div>
    </div>
  );
};

const Testimonial = () => {
  const scrollRef = useRef(null);

  const scroll = (direction) => {
    if (scrollRef.current) {
      const scrollAmount = 380;
      scrollRef.current.scrollBy({
        left: direction === 'left' ? -scrollAmount : scrollAmount,
        behavior: 'smooth'
      });
    }
  };

  return (
    <div className="testimonial">
      <div className="testimonial-wrapper" role="region" aria-label="Customer reviews">
        <button 
          type="button"
          className="scroll-arrow left" 
          onClick={() => scroll('left')}
          aria-label="Previous testimonials"
        />

        <div className="testimonial-scroll-container" ref={scrollRef} tabIndex="0" aria-label="Customer reviews. Scroll to read more.">
          {testimonials.map((item, i) => (
            <TestimonialCard key={i} item={item} />
          ))}
        </div>

        <button 
          type="button"
          className="scroll-arrow right" 
          onClick={() => scroll('right')}
          aria-label="Next testimonials"
        />
      </div>

      <p className="scroll-hint">Use the previous and next buttons or scroll to browse reviews.</p>
    </div>
  );
};

export default Testimonial;
